// ============================================================================
// API Endpoints — All URLs built from APP_CONFIG (single source of truth)
// ============================================================================

import { APP_CONFIG } from '../config/app.config';

const { BASE_URL, PORT_BASE, MEDIAFLOW_BASE_URL, APPAREL_USER_ID } = APP_CONFIG;

const GENAI_BASE_API_URL = {
  authUrl: import.meta.env.VITE_AUTH_API_URL,
  genaiUrl: import.meta.env.VITE_API_BASE_URL,
  integrationUrl: import.meta.env.VITE_INTEGRATION_BASE_URL,
  mediaflowUrl: import.meta.env.VITE_MEDIAFLOW_BASE_URL,
} as const;

const ENDPOINTS = {
  // ── Auth ──
  login: `${GENAI_BASE_API_URL.authUrl}/login`,
  logout: `${GENAI_BASE_API_URL.authUrl}/logout`,
  forgotPassword: `${GENAI_BASE_API_URL.authUrl}/forgot-password`,
  resetPassword: `${GENAI_BASE_API_URL.authUrl}/reset-password`,

  // Customization
  customizeFurniture: `${PORT_BASE}/customize/customize_furniture_bulk`,
  deleteCache: `${PORT_BASE}/customize/delete_cache`,

  // Swatches
  frameFabrics: `${PORT_BASE}/swatches/frame-fabrics`,
  seatFabrics: `${PORT_BASE}/swatches/seat-fabrics`,
  backCushionFabrics: `${PORT_BASE}/swatches/back-cushion-fabrics`,
  armrestFabrics: `${PORT_BASE}/swatches/armrest-fabrics`,
  woodFinishes: `${PORT_BASE}/swatches/wood-finishes`,
  nailheadSizes: `${PORT_BASE}/swatches/nailhead-sizes`,

  // Demo-2 product swatches
  ralphTwoFabricSofa: `${PORT_BASE}/swatches/ralph-two-fabric-sofa`,
  ralphSofaChairWoodFinishes: `${PORT_BASE}/swatches/ralph-sofa-chair-wood-finishes`,
  ralphChairSeatFabrics: `${PORT_BASE}/swatches/ralph-chair-seat-fabrics`,
  ralphChairBackCushionFabrics: `${PORT_BASE}/swatches/ralph-chair-back-cushion-fabrics`,
  ralphChairArmrestFabrics: `${PORT_BASE}/swatches/ralph-chair-armrest-fabrics`,

  // ── Tear Sheet ──
  furnitureWithDimensions: `${PORT_BASE}/image_visualisation/furniture_with_dimensions`,

  // ── Collections ──
  manualCollection: `${PORT_BASE}/openai/manual_collection`,
  generateCollections: `${PORT_BASE}/openai/generate_collections`,
  collectionFilters: `${PORT_BASE}/openai/collection_filters`,
  collectionProductSearch: `${PORT_BASE}/openai/collection_product_search`,
  addBundle: `${PORT_BASE}/lexiconne/menu/addBundle`,
  editBundle: `${PORT_BASE}/lexiconne/menu/editBundle`,
  // Dynamic (need query params)
  getBundles: (userId: string) =>
    `${PORT_BASE}/lexiconne/menu/getBundles?id=${APP_CONFIG.TYPE}&user_id=${APPAREL_USER_ID}`,
  deleteBundle: (pkId: string) =>
    `${PORT_BASE}/lexiconne/menu/deleteBundle?pk_ids=${pkId}&id=${APP_CONFIG.TYPE}`,

  // ── Styling Assistant (Streaming) ──
  STYLING_ASSISTANT: {
    buildSearchUrl: (query: string, userId: string, chatId: string) =>
      `${BASE_URL}/p5023/intelligent-search/extract-agent-fast?query=${encodeURIComponent(query)}&user_id=${userId}&chat_id=${chatId}`,
  },

  // ── Mediaflow ──
  mediaByCollection: (collectionId: string) =>
    `${MEDIAFLOW_BASE_URL}/images/media?collectionId=${collectionId}`,
  mediaByUser: (userId: string) =>
    `${MEDIAFLOW_BASE_URL}/images/media?userId=${APPAREL_USER_ID}`,
  imageGeneration: `${MEDIAFLOW_BASE_URL}/images/image-generation`,
  videoGeneration: `${MEDIAFLOW_BASE_URL}/images/video-generation`,
} as const;

export { GENAI_BASE_API_URL, ENDPOINTS };
export default ENDPOINTS;
